import {Box, Text} from '@mantine/core';
import type React from 'react';
import {MdClose} from 'react-icons/md';
import {
  URL_TO_ANDROID_APP_WEB,
  URL_TO_iOS_APP_WEB,
} from '../../../config/constants/routes';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

type Props = {
  closePopup: () => void;
};

export const MobilePromo: React.FC<Props> = ({closePopup}) => {
  const handlePressButton = () => {
    if (typeof window !== 'undefined') {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes('android')) {
        window.open(URL_TO_ANDROID_APP_WEB);
      } else {
        window.open(URL_TO_iOS_APP_WEB);
      }
    }
  };

  const {isPC} = useMediaQuery();
  return (
    <>
      {isPC ? (
        <Box className="flex flex-row justify-between items-center">
          <Box className="flex flex-row text-base text-black">
            外資就活ドットコムのアプリを使って誰よりも早く最新情報をGETしよう。
          </Box>
          <Box className="flex flex-row items-center gap-12">
            <Box
              className="cursor-pointer flex items-center justify-center border-primary border-[1px] bg-white rounded-[8px] py-8 px-12"
              onClick={handlePressButton}
            >
              <Text className="text-sm text-primary font-bold">
                インストールはこちら
              </Text>
            </Box>
            <Box
              className="w-24 h-24 flex items-center justify-center rounded-full bg-black-3 cursor-pointer"
              onClick={closePopup}
            >
              <MdClose size={24} color="white" />
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className="flex flex-row justify-between text-sm"
          onClick={handlePressButton}
        >
          <Text>
            外資就活ドットコムのアプリを使って誰よりも早く最新情報をGETしよう。
          </Text>
          <Box
            className="flex flex-row text-primary-1 items-center"
            onClick={(e) => {
              e.stopPropagation();
              closePopup();
            }}
          >
            <MdClose size={16} className="text-black-3" />
          </Box>
        </Box>
      )}
    </>
  );
};
